export default __webpack_public_path__ + "static/media/IMG_1346.37674283.37674283.JPG";